export default [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/onboarding/OnboardingList.vue'),
    meta: {
      action: 'read',
      Permission: 'no_permission_required',
    },
  },
  {
    path: '/onboarding/:id',
    name: 'onboarding-detail',
    component: () => import('@/views/onboarding/OnboardingDetail.vue'),
    meta: {
      action: 'read',
      Permission: 'no_permission_required',
    },
  },
  {
    path: '/client-onboarding/:token',
    name: 'client-onboarding',
    component: () => import('@/views/onboarding/public/ClientOnboarding.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
      Permission: 'no_permission_required',
    },
  },
];
